import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Popup } from '@elfsight/widget-modal';
import { useData } from '../../data';
import { Loader } from '../../lib/components';
// Импорт из index ломает сборку приложения
import { Post } from '../../post/Post';
import { useSocialFeedSettings } from '../../utils';
import { usePopup } from '../PopupProvider';
import { useScrollToPostRefGetter } from '../useScrollToPostRefGetter';

const POPUP_WIDTH = 600;

export const Feed = forwardRef<HTMLDivElement>((_, forwardingRef) => {
  const { isOpen, close, index } = usePopup();
  const {
    font,
    popupBackdropColor,
    popupBackgroundColor,
    popupBorderRadius,
    popupTextColor
  } = useSocialFeedSettings();
  const { data, next, hasNext } = useData();

  const getPostRef = useScrollToPostRefGetter(index);

  const handlePostVisibility = async (visible: boolean, postIndex: number) => {
    const isLastPostVisible = postIndex === data.length - 1 && visible;

    if (isLastPostVisible) {
      await next();
    }
  };

  return (
    <Popup
      ref={forwardingRef}
      width={POPUP_WIDTH}
      show={isOpen}
      backdropColor={popupBackdropColor}
      margin={[20, 20]}
      onCloseRequest={close}
      fixed
      withCloseControl
      closeControlPosition="outside"
      closeOnOutsideClick
      closeOnEscape
      withoutTransition
      ariaLabel="Social Feed Popup"
    >
      {isOpen && (
        <Content _borderRadius={popupBorderRadius} _font={font?.value}>
          {data.map((item, id) => (
            <PopupPost
              key={item.id || id}
              _backgroundColor={popupBackgroundColor}
              _dividerColor={popupTextColor}
              ref={getPostRef(id)}
            >
              <FeedPost
                isInPopup
                index={id}
                data={item}
                layout="popupFeed"
                onVisibilityChange={handlePostVisibility}
              />
            </PopupPost>
          ))}

          {hasNext && <PopupLoader _backgroundColor={popupBackgroundColor} />}
        </Content>
      )}
    </Popup>
  );
});

const Content = styled.div<{
  _borderRadius?: number;
  _font?: string;
}>`
  overflow: auto;
  border-radius: ${({ _borderRadius }) => _borderRadius ?? 8}px;
  margin: 0 auto;

  ${({ _font }) =>
    _font &&
    css`
      font-family: '${_font}';
    `};
`;

const PopupPost = styled.div<{
  _backgroundColor: string;
  _dividerColor: string;
}>`
  background: ${({ _backgroundColor }) => _backgroundColor};

  &:not(:last-child)::after {
    display: block;
    content: '';
    width: 100%;
    height: 8px;
    opacity: 0.1;
    background: ${({ _dividerColor }) => _dividerColor};
  }
`;

const FeedPost = styled(Post)``;

const PopupLoader = styled(Loader)<{
  _backgroundColor: string;
}>`
  padding: 40px 0;
  background: ${({ _backgroundColor }) => _backgroundColor};
`;
